import React from 'react';
import {
  shape,
  string,
  bool,
} from 'prop-types';

const TextBox = ({
  input, dataTestId, label, type, meta: { touched, error }, readOnly, style,
}) => {
  const hidden = type === 'hidden';
  const hasError = (touched || hidden) && error;
  let inputStyle = {};
  if (hidden) {
    inputStyle.border = 0;
    inputStyle.height = 'auto';
    if (!hasError) {
      inputStyle.margin = 'auto';
    }
  }

  inputStyle = style || inputStyle;

  return (
    <div className={`gcc-input ${hasError ? 'has-error' : ''}`} style={inputStyle}>
      <input
        {...input}
        id={input.name}
        data-test-id={dataTestId}
        type={type}
        className={`ba b--black-20 bw1 br3 pa2 pl2 ${input.value ? 'filled' : ''} ${readOnly ? 'read-only-gray' : ''}`}
        readOnly={readOnly}
      />
      {label && <label htmlFor={input.name} className="f5 pa2 pl2">{label}</label>}
      {hasError && <div className="gcc-input-help"><span className="error">{error}</span></div>}
    </div>
  );
};


TextBox.defaultProps = {
  dataTestId: '',
  style: undefined,
  readOnly: false,
};

TextBox.propTypes = {
  input: shape({}).isRequired,
  dataTestId: string,
  label: string.isRequired,
  type: string.isRequired,
  meta: shape({}).isRequired,
  style: shape({}),
  readOnly: bool,
};

export default TextBox;
